function bindSortableQuestion(questionId) {
  $("#sortable_" + questionId).sortable({axis: "y", containment: "#survey-question-id-" + questionId});
  $("#sortable_" + questionId).disableSelection();
  function fill_hidden_field_for_rank() {
    hidden_field = $("#q_" + questionId);
    new_value    = $(this).sortable("toArray").map(function(val){ return $('#'+val).data('option'); }).join("||");
    hidden_field.val(new_value);
  }

  $(document).on("sortupdate","#sortable_" + questionId, fill_hidden_field_for_rank );
  initialise_keyups(questionId);
}
/** Add keyboard accessibility to survey ranking widget by listening for key presses on focussed items **/
function initialise_keyups(questionId) {
	$("#sortable_" + questionId + " .ranking").keyup(function(e) {
		var KEYUP = 38;
		var KEYDOWN = 40;
		var $focused = $(':focus');
		if (e.which == KEYUP) {
			e.preventDefault();
			var $prev = $($focused).prev();
			$($focused).insertBefore($prev).focus();
		}
		if (e.which == KEYDOWN) {
			e.preventDefault();
			var $next = $($focused).next();
			$($focused).insertAfter($next).focus();
		}
	});
}

/*** EXPORTS FROM exports-loader ***/
module.exports = bindSortableQuestion;